import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clinic-history-tabs"
// The document-type tabs (Todo, H. Enfermería, Epicrisis, ...) are switched entirely
// client-side (Bootstrap tabs), so nothing tells the server which one was active. Any full
// page reload of the patient show (refresh, back/forward, navigating away and back) re-renders
// with "Todo" hardcoded as active, silently discarding whatever tab/filter the user had
// selected. This controller keeps the active tab in the URL so it survives those reloads.
export default class extends Controller {
  static values = { param: { type: String, default: 'active_doc_tab' } }

  connect() {
    this.onTabClick = this.onTabClick.bind(this)
    this.element.addEventListener('click', this.onTabClick)
    this.restoreActiveTab()
  }

  disconnect() {
    this.element.removeEventListener('click', this.onTabClick)
  }

  onTabClick(event) {
    const link = event.target.closest('[data-toggle="tab"]')
    if (!link) return

    this.persistActiveTab(link.getAttribute('href'))
  }

  restoreActiveTab() {
    const tabId = new URLSearchParams(window.location.search).get(this.paramValue)
    if (!tabId || tabId === 'all') return

    const link = this.element.querySelector(`[data-toggle="tab"][href="#${tabId}"]`)
    if (link) new bootstrap.Tab(link).show()
  }

  persistActiveTab(href) {
    const tabId = (href || '').replace('#', '')
    if (!tabId) return

    const url = new URL(window.location.href)
    tabId === 'all' ? url.searchParams.delete(this.paramValue) : url.searchParams.set(this.paramValue, tabId)
    window.history.replaceState(window.history.state, '', url.toString())
  }
}
